import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { ProjectLocationCustomNotesForm } from "./Form";
import { AccountType } from "../../../../../models/AccountData";
import {
  ProjectsLocationsData,
  UpdateProjectLocationPayload
} from "../../../../../models/ProjectData";
import { OptionalRender } from "../../../../Common/OptionalRender";
import { useProjectsLocations } from "../../hooks";

import "./styles.scss";

interface IProjectLocationCustomNotesProps {
  organizationId: string;
  projectLocation?: ProjectsLocationsData;
}

export const ProjectLocationCustomNotes: React.FC<
  IProjectLocationCustomNotesProps
> = (props) => {
  const { organizationId, projectLocation } = props;
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(
      `projectManagementPage.projectFacilityDetailsModal.projectLocationCustomNotes.${key}`
    );

  const [isEditMode, setIsEditMode] = useState(false);

  const { updateProjectLocation } = useProjectsLocations(
    organizationId,
    projectLocation?.project_id.toString()
  );

  const handleEdit = () => {
    setIsEditMode((v) => !v);
  };

  const handleClose = () => {
    setIsEditMode(false);
  };

  const handleSubmit = async (payload: UpdateProjectLocationPayload) => {
    await updateProjectLocation({
      projectLocationId: projectLocation?.id.toString(),
      payload
    });
    handleClose();
  };
  return (
    <>
      <div className="project-location-custom-notes">
        <div className="project-location-custom-notes-container">
          <div className="project-location-custom-notes-header">
            <h2 className="project-location-custom-notes-title">
              {t("custom_notes")}
            </h2>
            <OptionalRender mustBeOneOfRoles={[AccountType.ADMIN]}>
              <button className="edit-button" onClick={handleEdit}></button>
            </OptionalRender>
          </div>
          <div className="project-location-custom-notes-content">
            {projectLocation?.custom_notes}
          </div>
        </div>
      </div>
      {isEditMode && projectLocation && (
        <ProjectLocationCustomNotesForm
          projectLocation={projectLocation}
          handleSubmit={handleSubmit}
          handleClose={handleClose}
        />
      )}
    </>
  );
};
